<template>
  <div>
    <div v-for="answer in answerSet" :key="answer">
      <button
        class="btn btn-outline-primary btn-lg w-100  mb-3"
        @click="checkAnswer(answer)"
      >
        {{ answer }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnswerBlock",
  props: {
    answerSet: Array
  },
  methods: {
    checkAnswer(answer) {
      this.$emit("checkAnswer", answer);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
